"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PaddingProps = exports.MarginProps = void 0;
var _breakpoints = require("./breakpoints");
var _memoize = _interopRequireDefault(require("./memoize"));
var _merge = _interopRequireDefault(require("./merge"));
const StringIsNumber = value => isNaN(Number(value)) === false;
const ToArray = enumme => Object.keys(enumme).filter(StringIsNumber).map(key => enumme[key]);
const properties = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const propertiesArray = Object.keys(properties);
const directionsArray = Object.keys(directions);
let MarginProps = exports.MarginProps = /*#__PURE__*/function (MarginProps) {
  MarginProps[MarginProps["m"] = 0] = "m";
  MarginProps[MarginProps["mr"] = 1] = "mr";
  MarginProps[MarginProps["ml"] = 2] = "ml";
  MarginProps[MarginProps["mx"] = 3] = "mx";
  MarginProps[MarginProps["mt"] = 4] = "mt";
  MarginProps[MarginProps["mb"] = 5] = "mb";
  MarginProps[MarginProps["my"] = 6] = "my";
  return MarginProps;
}({});
let PaddingProps = exports.PaddingProps = /*#__PURE__*/function (PaddingProps) {
  PaddingProps[PaddingProps["p"] = 0] = "p";
  PaddingProps[PaddingProps["pr"] = 1] = "pr";
  PaddingProps[PaddingProps["pl"] = 2] = "pl";
  PaddingProps[PaddingProps["px"] = 3] = "px";
  PaddingProps[PaddingProps["pt"] = 4] = "pt";
  PaddingProps[PaddingProps["pb"] = 5] = "pb";
  PaddingProps[PaddingProps["py"] = 6] = "py";
  return PaddingProps;
}({});
const spacingProps = [...ToArray(MarginProps), ...ToArray(PaddingProps)];
const insetSquishedValue = ['xs-squished', 'sm-squished', 'md-squished', 'lg-squished', 'xl-squished'];
function isTypeOf(key, arr) {
  return arr.includes(key);
}

// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = (0, _memoize.default)(key => {
  const [a, b] = key.split('');
  if (isTypeOf(a, propertiesArray) && (isTypeOf(b, directionsArray) || typeof b === 'undefined')) {
    const property = properties[a];
    const direction = directions[b] || '';
    return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
  }
  return [];
});
function getTransformer(theme) {
  const baseUnit = theme.busbud.space.base;
  return value => {
    if (isTypeOf(value, [...insetSquishedValue])) {
      const key = value.substring(0, 2);
      const {
        x,
        y
      } = theme.busbud.space.insetSquished[key];
      return `${y} ${x}`;
    }
    if (typeof value === 'number') {
      return `${value * baseUnit}px`;
    }
    return value;
  };
}
function getStyleFromPropValue(cssProperties, transformer) {
  return value => {
    const style = {};
    cssProperties.forEach(cssProperty => {
      style[cssProperty] = transformer(value);
    });
    return style;
  };
}
function filterSpacingProps(props) {
  return Object.keys(props).filter(prop => isTypeOf(prop, spacingProps));
}
function spacing(props) {
  const theme = props.theme;
  const transformer = getTransformer(theme);
  return filterSpacingProps(props).map(prop => {
    const cssProperties = getCssProperties(prop);
    const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    // @ts-ignore
    return (0, _breakpoints.handleBreakpoints)(theme, propValue, styleFromPropValue);
  }).reduce(_merge.default, {});
}
spacing.filterProps = spacingProps;
var _default = exports.default = spacing;